import APIService from '../APIService';
import config from '../../../config';

export default class NotificationService extends APIService {
    // if token already exists in store, dont send another request to create client
    static createClient() {
        return this.get(`${config.baseUrlForNotificationService}/client`);
    }

    static deleteClient(clientId) {
        return this.delete(`${config.baseUrlForNotificationService}/client/${clientId}`);
    }

    // eslint-disable-next-line
    static getNotificationsForDuration(postBody) {
        return this.post(`${config.baseUrlForNotificationService}/message`, postBody);
    }

    static sendSampleNotif(postBody) {
        return this.post(`${config.baseUrlForNotificationService}/notification`, postBody);
    }

    static markAsSeen(postBody) {
        return this.put(`${config.baseUrlForNotificationService}/message/seen`, {
            ids: postBody
        });
    }

    static markAllAsSeen() {
        return this.put(`${config.baseUrlForNotificationService}/message/markAllAsRead`);
    }
}

